import { NSARouterMakerResult, NSAHomePage } from "namirasoft-account-react";
import { TeamsSenderLayout } from "../TeamsSenderLayout";
import { TeamsSenderRouterProps } from "../TeamsSenderRouterProps";

export interface HomePageProps extends NSARouterMakerResult, TeamsSenderRouterProps { }

export default function HomePage(props: HomePageProps)
{
	return (
		<TeamsSenderLayout
			{...props}
		>
			<NSAHomePage
				{...props}
			/>
		</TeamsSenderLayout>
	);
}